import { Link } from 'react-router-dom';
import { Calculator, Activity, Heart, Stethoscope, Baby, Brain } from 'lucide-react';
import type { Calculator as CalculatorType } from '../data/calculators';

const categoryIcons = {
  'critical-care': Activity,
  'cardiology': Heart,
  'nephrology': Stethoscope,
  'infectious': Calculator,
  'pediatrics': Baby,
  'general': Brain
};

const categoryColors = {
  'critical-care': 'bg-red-100 text-red-700',
  'cardiology': 'bg-pink-100 text-pink-700',
  'nephrology': 'bg-purple-100 text-purple-700',
  'infectious': 'bg-orange-100 text-orange-700',
  'pediatrics': 'bg-blue-100 text-blue-700',
  'general': 'bg-green-100 text-green-700'
};

interface CalculatorCardProps {
  calculator: CalculatorType;
}

export default function CalculatorCard({ calculator }: CalculatorCardProps) {
  const Icon = categoryIcons[calculator.category];
  const colorClass = categoryColors[calculator.category];

  return (
    <Link
      to={`/calculators/${calculator.id}`}
      className="bg-white rounded-xl shadow-sm hover:shadow-lg transition-all p-6 border border-gray-200 hover:border-blue-300"
    >
      <div className="flex items-start gap-4">
        <div className={`p-3 rounded-xl ${colorClass}`}>
          <Icon className="w-6 h-6" />
        </div>
        <div className="flex-1">
          <h3 className="font-bold text-gray-900 mb-1 text-lg">{calculator.shortName}</h3>
          <p className="text-sm text-gray-700 line-clamp-2">{calculator.description}</p>
          <div className="mt-3">
            <span className={`text-xs font-semibold px-2 py-1 rounded-full ${colorClass}`}>
              {calculator.category.replace('-', ' ')}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}
